import React from "react";

export default function HorariosForm({
  config,
  days,
  loading,
  isEditing,
  timeErrors,
  onChangeConfig,
  onChangeDays,
  onSave,
  isSaving,
  error
}) {
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <span className="text-secondary">Cargando configuración de horarios...</span>
      </div>
    );
  }

  // Responsive helpers
  const cardStyle = {
    minWidth: 220,
    flex: "1 1 260px",
    marginBottom: 16,
    border: "1px solid #e3e6f0",
    borderRadius: 12,
    padding: 18,
    background: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    transition: "box-shadow 0.2s",
  };

  const labelStyle = {
    fontWeight: 600,
    marginBottom: 8,
    color: "#2d3a4b",
    fontSize: 16,
  };

  const sectionStyle = {
    margin: "24px 0",
    display: "flex",
    flexWrap: "wrap",
    gap: 24,
    justifyContent: "center",
  };

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        onSave();
      }}
      style={{
        maxWidth: 900,
        margin: "0 auto",
        background: "#f8f9fc",
        borderRadius: 16,
        padding: 32,
        boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
      }}
    >
      <h3 className="text-center mb-4" style={{ color: "#0d6efd", fontWeight: 700 }}>
        Configuración de Horarios
      </h3>
      <div style={sectionStyle}>
        {days.map((day, idx) => (
          <div key={day.label} style={cardStyle}>
            <div style={labelStyle}>{day.label}</div>
            <label style={{ fontWeight: 500, color: "#555" }}>
              <input
                type="checkbox"
                checked={day.available}
                disabled={!isEditing}
                onChange={e => {
                  const updatedDays = days.map(d =>
                    d.label === day.label ? { ...d, available: e.target.checked } : d
                  );
                  onChangeDays(updatedDays);
                }}
                style={{ marginRight: 8 }}
              />
              Disponible
            </label>
            {day.available && (
              <div>
                {day.timeRanges.map((range, rangeIdx) => (
                  <div
                    key={rangeIdx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      marginBottom: 6,
                    }}
                  >
                    <input
                      type="time"
                      value={range.start}
                      disabled={!isEditing}
                      onChange={e =>
                        handleTimeChange(day.label, rangeIdx, "start", e.target.value)
                      }
                      style={{
                        width: 90,
                        border: "1px solid #d1d5db",
                        borderRadius: 6,
                        padding: "4px 8px",
                        background: "#f9fafb",
                      }}
                    />
                    <span style={{ color: "#888" }}>a</span>
                    <input
                      type="time"
                      value={range.end}
                      disabled={!isEditing}
                      onChange={e =>
                        handleTimeChange(day.label, rangeIdx, "end", e.target.value)
                      }
                      style={{
                        width: 90,
                        border: "1px solid #d1d5db",
                        borderRadius: 6,
                        padding: "4px 8px",
                        background: "#f9fafb",
                      }}
                    />
                    {isEditing && (
                      <button
                        type="button"
                        onClick={() => removeTimeRange(day.label, rangeIdx)}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#d9534f",
                          fontSize: 20,
                          cursor: "pointer",
                          marginLeft: 4,
                        }}
                        title="Eliminar rango"
                      >
                        ×
                      </button>
                    )}
                  </div>
                ))}
                {isEditing && (
                  <button
                    type="button"
                    onClick={() => addTimeRange(day.label)}
                    style={{
                      marginTop: 6,
                      background: "#e9ecef",
                      border: "1px solid #b6c2d2",
                      borderRadius: 6,
                      cursor: "pointer",
                      padding: "4px 12px",
                      fontWeight: 500,
                      color: "#0d6efd",
                    }}
                  >
                    + Añadir horario
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="row g-3" style={{ margin: "32px 0 0 0" }}>
        <div className="col-md-6">
          <label className="form-label" style={labelStyle}>
            Duración de la cita:
          </label>
          <select
            className="form-select"
            value={config.duracionCitaMin}
            onChange={e => onChangeConfig('duracionCitaMin', e.target.value)}
            disabled={!isEditing}
          >
            <option value="15">15 minutos</option>
            <option value="30">30 minutos</option>
            <option value="45">45 minutos</option>
            <option value="60">60 minutos</option>
          </select>
        </div>
        <div className="col-md-6">
          <label className="form-label" style={labelStyle}>
            Plazo máximo para programar citas (días):
          </label>
          <input
            type="number"
            min="0"
            className="form-control"
            value={config.plazos?.maxDays || ""}
            onChange={e => onChangeConfig('plazos.maxDays', e.target.value)}
            disabled={!isEditing}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label" style={labelStyle}>
            Plazo mínimo de anticipación (horas):
          </label>
          <input
            type="number"
            min="0"
            className="form-control"
            value={config.plazos?.minHours || ""}
            onChange={e => onChangeConfig('plazos.minHours', e.target.value)}
            disabled={!isEditing}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label" style={labelStyle}>
            Margen de tiempo entre citas (minutos):
          </label>
          <input
            type="number"
            min="0"
            className="form-control"
            value={config.citasReservadas?.duracionPeriodo?.tiempo || ""}
            onChange={e => onChangeConfig('citasReservadas.duracionPeriodo.tiempo', e.target.value)}
            disabled={!isEditing}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label" style={labelStyle}>
            Máximo de reservas por día:
          </label>
          <input
            type="number"
            min="1"
            className="form-control"
            value={config.citasReservadas?.maxReservas?.cantidad || ""}
            onChange={e => onChangeConfig('citasReservadas.maxReservas.cantidad', e.target.value)}
            disabled={!isEditing}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label" style={labelStyle}>
            Flujo de agenda para pacientes:
          </label>
          <div className="mt-2">
            <label htmlFor="mostrarDisponibilidadDiaria" style={{ fontWeight: 500, fontSize: "15px", color: "#0d6efd", cursor: "pointer", display: "inline-flex", alignItems: "center" }}>
              <input
                type="checkbox"
                id="mostrarDisponibilidadDiaria"
                checked={config.plazos?.mostrarDisponibilidadDiaria || false}
                onChange={e => onChangeConfig('plazos.mostrarDisponibilidadDiaria', e.target.checked)}
                disabled={!isEditing}
                style={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                  marginRight: 10,
                }}
              />
              Mostrar solo disponibilidad diaria (Flujo guiado)
            </label>
          </div>
          <small className="text-muted d-block mt-1" style={{ fontSize: "12px", lineHeight: "1.4" }}>
            Si está activo, los pacientes verán un flujo guiado seleccionando un día y no la disponibilidad completa de varios días a la vez (evita mostrar grillas con pocos horarios).
          </small>
        </div>
      </div>

      <div className="d-flex justify-content-center mt-4">
        <button
          type="submit"
          disabled={isSaving}
          className="btn btn-primary px-5 py-2"
          style={{ fontSize: 18, fontWeight: 600, borderRadius: 8 }}
        >
          {isSaving ? "Guardando..." : "Guardar Cambios"}
        </button>
      </div>
      {error && (
        <div className="alert alert-danger mt-3 text-center" style={{ maxWidth: 400, margin: "0 auto" }}>
          {error}
        </div>
      )}
    </form>
  );

  // Helpers (pueden ir fuera del componente si prefieres)
  function handleTimeChange(dayLabel, rangeIdx, field, value) {
    const updatedDays = days.map(day => {
      if (day.label !== dayLabel) return day;
      const updatedRanges = day.timeRanges.map((range, idx) =>
        idx === rangeIdx ? { ...range, [field]: value } : range
      );
      return { ...day, timeRanges: updatedRanges };
    });
    onChangeDays(updatedDays);
  }

  function addTimeRange(dayLabel) {
    const updatedDays = days.map(day =>
      day.label === dayLabel
        ? { ...day, available: true, timeRanges: [...day.timeRanges, { start: "", end: "" }] }
        : day
    );
    onChangeDays(updatedDays);
  }

  function removeTimeRange(dayLabel, rangeIdx) {
    const updatedDays = days.map(day => {
      if (day.label !== dayLabel) return day;
      const newRanges = day.timeRanges.filter((_, idx) => idx !== rangeIdx);
      return { ...day, timeRanges: newRanges };
    });
    onChangeDays(updatedDays);
  }
}